import styled from "styled-components";
import { MEDIA_QUERY } from "../../entities/Common";

export const ModalStyle = styled.div`
  max-width: calc(100vw - 30px);
  @media (min-width: ${MEDIA_QUERY.LAPTOP}) {
    border-radius: 0.25rem;
    max-width: 50vw;
    padding: 0;
    top: 50vh !important;
    transform: translateY(-50%) !important;
    min-height: max-content !important;
    max-height: 95vh;
    margin: 0 auto;
  }
`;

export const OverlayStyle = styled.div`
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: scroll;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 3500;
  background: rgba(0, 0, 0, 0.5) !important;
`;
